import { CalendarImageSelector } from './CalendarImageSelector';
import { CalendarPreview } from './CalendarPreview';
import { FontSelector } from './FontSelector';
import { ColorSelector } from './ColorSelector';
import { CalendarLocationSectionProps } from '../../types/calendar';

export function CalendarLocationSection({
  title,
  calendarImages,
  fontOptions,
  location,
  formPosition,
  altText,
  showRemove = false,
  onFieldChange,
  onImageSelect,
  onFontSelect,
  onColorSelect,
  onRemove,
  onMouseDown,
  onMouseMove,
  onMouseUp
}: CalendarLocationSectionProps) {
  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
        {showRemove && onRemove && (
          <button
            onClick={onRemove}
            className="text-gray-400 hover:text-gray-600 text-sm font-medium"
          >
            Remove
          </button>
        )}
      </div>
      <div className="space-y-4">
        <CalendarImageSelector
          images={calendarImages}
          selectedImageId={location.calendarImage}
          onImageSelect={onImageSelect}
        />
        <FontSelector
          fontOptions={fontOptions}
          selectedFont={location.fontFamily || 'Inter, sans-serif'}
          onFontSelect={onFontSelect}
        />
        <ColorSelector
          selectedColor={location.textColor || '#000000'}
          onColorSelect={onColorSelect}
        />
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Form Background Opacity
          </label>
          <div className="flex items-center gap-3">
            <input
              type="range"
              min="0"
              max="1"
              step="0.05"
              value={location.formOpacity ?? 0.2}
              onChange={(e) => onFieldChange('formOpacity', e.target.value)}
              className="flex-1 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-600"
            />
            <span className="text-sm text-gray-600 w-12 text-right">
              {Math.round((location.formOpacity ?? 0.2) * 100)}%
            </span>
          </div>
        </div>
        <CalendarPreview
          calendarImages={calendarImages}
          location={location}
          formPosition={formPosition}
          altText={altText}
          onFieldChange={onFieldChange}
          onMouseDown={onMouseDown}
          onMouseMove={(e, scaleFactor) => onMouseMove(e, scaleFactor)}
          onMouseUp={onMouseUp}
        />
      </div>
    </div>
  );
}
